import ApiBase from 'app/api/base';
import { updateCouponLinks } from 'app/desktop/actions/navbar';

export default class DesktopApi extends ApiBase {
  static init(store) {
    window.Groupon = Object.assign({}, window.Groupon, {
      LSApp: new DesktopApi(store),
    });
  }

  setCouponLinks(links) {
    this.store.dispatchEvent(updateCouponLinks(links));
  }
}
